/**
 * Bridal Bouquets lookbook — portrait grid lightbox.
 * Inquire CTAs use data-opens-form (handled by section-inquiry-forms.js).
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__odeBridalInit) return;
    root.__odeBridalInit = true;

    var section = root.closest('.shopify-section') || document;
    var lightbox = section.querySelector('[data-bridal-lightbox]');
    if (!lightbox) lightbox = document.querySelector('[data-bridal-lightbox]');
    if (!lightbox) return;

    var lbImage = lightbox.querySelector('[data-bridal-lightbox-image]');
    var lastFocus = null;

    function openLightbox(src, alt, trigger) {
      if (!src || !lbImage) return;
      lastFocus = trigger || document.activeElement;
      lbImage.src = src;
      lbImage.alt = alt || '';
      lightbox.hidden = false;
      document.body.classList.add('ode-bridal-lb-open');
      var closeBtn = lightbox.querySelector('.ode-bridal-lb__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      if (lightbox.hidden) return;
      lightbox.hidden = true;
      document.body.classList.remove('ode-bridal-lb-open');
      if (lbImage) {
        lbImage.removeAttribute('src');
        lbImage.alt = '';
      }
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    root.querySelectorAll('[data-bridal-card]').forEach(function (card) {
      card.addEventListener('click', function () {
        openLightbox(card.getAttribute('data-bridal-src'), card.getAttribute('data-bridal-alt'), card);
      });
    });

    lightbox.querySelectorAll('[data-bridal-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });

    /* Closing lightbox when opening inquiry form */
    lightbox.querySelectorAll('[data-opens-form]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeLightbox();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (!lightbox.hidden) {
        e.preventDefault();
        closeLightbox();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-ode-bridal-lbk]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
